









































import { defineComponent, ref } from "@vue/composition-api";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import DataTable from "@/components/data/data-table.vue";
import { Office } from "@/swagger/models";
import { DataTableConfig } from "@/components/data/data-table";
import { useRouter } from "@/router/router";
import { officeService } from "@/services/office";

export default defineComponent({
    name: "offices-table",
    props: {
        customerId: {
            type: Number,
            required: true,
        },
    },
    components: { Page, PageHeader, DataTable },
    setup(props, context) {
        const { router } = useRouter(context);

        const offices = ref<Office[]>([]);
        const loading = ref(false);

        (async () => {
            loading.value = true;
            offices.value = await officeService.find({ params: { customer: props.customerId } });
            loading.value = false;
        })();

        const tableConfig: DataTableConfig<Office> = {
            clickItemCallback: (item) => {
                router.push({
                    name: "office",
                    params: {
                        officeId: item.id.toString(),
                    },
                });
            },
            items: offices,
            fields: [
                {
                    label: "ID",
                    field: "id",
                    compact: true,
                },
                {
                    label: "Name",
                    field: "name",
                },
                {
                    label: "Created",
                    field: "createdAt",
                    compact: true,
                },
                {
                    label: "Updated",
                    field: "updatedAt",
                    compact: true,
                },
            ],
        };

        return { tableConfig, loading };
    },
});
